export enum RequestStatus {
    none = 'NO_REQUEST',
    active = 'ACTIVE_REQUEST',
    success = 'REQUEST_SUCCESS',
    error = 'REQUEST_ERROR',
}
